export default __webpack_public_path__ + "static/media/Stalker's Tunic of Charred Earth.3c5c4229.jpg";